import { Modal } from "@mui/material";
import React from "react";
import "./ReleaseTableDrawer.css";

const ReleaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#dc2626"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const ReleaseTableDrawer = ({
  open,
  onClose,
  tableName,
  onConfirm,
  loading = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      slotProps={{ backdrop: { style: { backgroundColor: "rgba(0,0,0,0.35)" } } }}
    >
      <div className="rtd-shell">
        {/* Header */}
        <div className="rtd-header">
          <div>
            <span className="rtd-supertitle">CART ACTION</span>
            <h2 className="rtd-title">Release table</h2>
          </div>
          <button className="rtd-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="rtd-body">
          <div className="rtd-icon-wrap">
            <ReleaseIcon />
          </div>

          <h3 className="rtd-confirm-title">
            Release{tableName ? ` ${tableName}` : " Table"}?
          </h3>
          <p className="rtd-confirm-sub">
            This will clear the current order and make the table available.
          </p>

          <div className="rtd-actions">
            <button className="rtd-btn-cancel" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button className="rtd-btn-confirm" onClick={onConfirm} disabled={loading}>
              {loading ? "Releasing…" : "Confirm Release"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReleaseTableDrawer;
